export const STUDIO = {
  name: 'Ayumi Suzuki Massage Therapy',
  street: '2528 I Street',
  city: 'Sacramento',
  region: 'CA',
  zip: '95816',
  phoneDisplay: '415-678-9133',
  phoneE164: '+14156789133',
  email: 'ayumisuzuki@yahoo.com',
  hours: 'Tue – Sat · 9 AM – 6 PM · by appointment',
  lat: '38.5734',
  lng: '-121.4785',
};

export const PAGE_URL = 'https://ayumisuzuki.com/massage-midtown-sacramento';
export const MAP_EMBED = 'https://www.google.com/maps?q=2528+I+Street,+Sacramento,+CA+95816&output=embed';
export const MAP_LINK = 'https://www.google.com/maps/search/?api=1&query=2528+I+Street+Sacramento+CA+95816';
export const DIRECTIONS_LINK = 'https://www.google.com/maps/dir/?api=1&destination=2528+I+Street+Sacramento+CA+95816';
export const HERO_IMG = 'https://images.squarespace-cdn.com/content/v1/68ebb6751f9d04372e40f528/1761329558856-2WNFM7KJRJH0TIZ1NX5U/unsplash-image-3aGV2ViCzrM.jpg';
export const AYUMI_IMG = 'https://customer-assets.emergentagent.com/job_suzuki-2026-refresh/artifacts/aautielc_Ayumi.jpg';

export const MIDTOWN_POCKETS = [
  'Boulevard Park',
  'Newton Booth',
  'Poverty Ridge',
  'Marshall Park',
  'Winn Park',
  'Lavender Heights',
  'R Street Corridor',
  "Sutter's Fort",
];

export const NEARBY_GUIDES = [
  { name: 'Downtown', to: '/blog/downtown-sacramento-massage-therapist' },
  { name: 'East Sacramento', to: '/blog/east-sacramento-massage-therapist' },
  { name: 'Curtis Park', to: '/blog/curtis-park-massage-therapist' },
  { name: 'Land Park', to: '/blog/land-park-massage-therapist' },
  { name: 'Oak Park', to: '/blog/back-and-neck-pain-massage-oak-park' },
  { name: 'The Pocket', to: '/blog/back-and-neck-pain-massage-the-pocket' },
  { name: 'Arden-Arcade', to: '/blog/back-and-neck-pain-massage-arden-arcade' },
  { name: 'Carmichael', to: '/blog/back-and-neck-pain-massage-carmichael' },
  { name: 'Elmhurst', to: '/blog/back-and-neck-pain-massage-elmhurst' },
];

export const MIDTOWN_GUIDES = [
  { title: 'A Certified Swedish Massage in Midtown Sacramento — What the Hour Looks Like', to: '/blog/certified-swedish-massage-midtown-sacramento' },
  { title: 'Massage Therapy in Midtown Sacramento — The Local Guide', to: '/blog/massage-therapy-midtown-sacramento' },
  { title: 'Certified Massage Therapist in Midtown Sacramento', to: '/blog/certified-massage-therapist-midtown-sacramento' },
  { title: 'Swedish Massage in Midtown Sacramento, CA — A Personal Note', to: '/blog/swedish-massage-midtown-sacramento-ca' },
  { title: 'Deep Tissue vs Swedish in Midtown — Which Should You Book?', to: '/blog/deep-tissue-vs-swedish-massage-midtown-sacramento' },
  { title: 'Healing Massage Therapy in Midtown Sacramento', to: '/blog/healing-massage-therapy-midtown-sacramento' },
];

export const LUNCH_RESET = {
  price: 55,
  minutes: 30,
  window: '11 AM – 2 PM',
  days: 'Tuesday – Saturday',
  daysShort: 'Tue – Sat',
};

export const MIDTOWN_FAQ = [
  {
    q: 'Can I get a massage on my lunch break in Midtown Sacramento?',
    a: "Yes — that's exactly what the Midtown Lunch Reset is for. It's a focused 30-minute massage for $55, with lunch-hour slots from 11 AM to 2 PM, Tuesday through Saturday, at 2528 I Street. It's built for state workers and Sutter staff who need to be back at their desk or on shift within the hour.",
  },
  {
    q: 'Where is the massage studio in Midtown Sacramento?',
    a: "The studio is at 2528 I Street, Sacramento, CA 95816 — in Midtown, a few blocks from Sutter's Fort and Sutter Medical Center. It's a private, one-client-at-a-time space, open Tuesday through Saturday by appointment.",
  },
  {
    q: 'Is there parking near the Midtown studio?',
    a: 'Yes. Street parking is available on I Street and the surrounding blocks, and there are several paid lots nearby. Midtown is very walkable and bikeable, so many clients come on foot or by bike.',
  },
  {
    q: 'How much is a massage in Midtown Sacramento?',
    a: 'At my Midtown studio: 30 minutes $55, 45 minutes $70, 60 minutes $110, 90 minutes $160, and 120 minutes $200. Every session is one-on-one and tailored — Swedish, deep tissue, or therapeutic work, blended to what your body needs that day.',
  },
  {
    q: 'Are you a certified massage therapist?',
    a: "Yes — I'm a CAMTC-certified massage therapist (California Massage Therapy Council). You can verify any California therapist's certification by searching their name at camtc.org.",
  },
  {
    q: 'Which neighborhoods do your Midtown clients come from?',
    a: 'Mostly Midtown itself — Boulevard Park, Newton Booth, Poverty Ridge, Marshall Park, Lavender Heights and the R Street Corridor — plus Downtown, East Sacramento, Curtis Park, Land Park, Oak Park and the Pocket, which are all a short drive away.',
  },
  {
    q: 'How do I book a massage in Midtown Sacramento?',
    a: 'Book online at ayumisuzuki.com/book — you can see every open slot and pick your session length. If you have a question first, text me at 415-678-9133.',
  },
];
